import React from 'react';
import { MediaItem } from '../types/MediaItem';

interface MediaViewerProps {
  item: MediaItem;
  onClose: () => void;
}

const MediaViewer: React.FC<MediaViewerProps> = ({ item, onClose }) => {
  return (
    <div className="media-viewer">
      {item.type === 'image' ? (
        <img src={item.url} alt="Media content" />
      ) : (
        <video src={item.url} controls />
      )}
      <button onClick={onClose}>Close</button>
    </div>
  );
};

export default MediaViewer;